<template>
    <!-- Portafolio -->
    <div class="section mt-4">
        <div class="section-heading">
            <h2 class="title">Mi portafolio</h2>
            <!-- <router-link :to="{ name: 'crypto-portfolio' }" class="link">
                Ver todo
            </router-link> -->
        </div>
        <div class="card">
            <!-- {{ currencies }} -->
            <ul class="listview flush transparent no-line image-listview detailed-list mt-1 mb-1">
                <!-- ítem -->
                <li class="placeholder-glow" v-if="loading == true">
                    <!-- asset: {{ asset }} <br /> -->
                    <div class="item">
                        <div class="icon-box text-success">
                            <p class="placeholder col"></p>
                        </div>
                        <div class="in">
                            <div>
                                <strong class="placeholder col-6"></strong>
                                <div class="text-small text-secondary"></div>
                            </div>
                            <div class="text-end">
                                <strong class="placeholder col-6">
                                </strong>
                                <div class="text-small"></div>
                            </div>
                        </div>
                    </div>
                </li>
                <template v-else v-for="(asset, c_i) in portfolio">
                    <template v-if="asset.networks_balance.length == 1">
                      <li v-bind:key="'c_i'+c_i">
                        <div class="item">
                          <div class="icon-box text-success">
                              <img :src="asset.image" height="100%" />
                          </div>
                          <div class="in">
                              <div>
                                  <strong>{{asset.name}}</strong>
                                  <div class="text-small text-secondary">
                                    TRM: ~{{ asset.price.general }} COP x 1 {{asset.symbol}}
                                    <br />
                                    Compra: ~{{ asset.price.buy }} COP x 1 {{asset.symbol}} <br />
                                    Venta:   1 {{asset.symbol}}  x ~{{ asset.price.sell }} COP
                                  </div>
                                  <div class="text-small">
                                    <!-- <div :title="asset.networks_balance[0].network.name" data-bs-toggle="tooltip" data-bs-placement="top">
                                      <span class="badge text-secondary align-middle">
                                        <img :src="asset.networks_balance[0].network.image" height="18px" />
                                      </span>
                                      {{ parseFloat(asset.networks_balance[0].balance).toFixed(asset.networks_balance[0].decimals) }} {{ asset.symbol }}
                                    </div> -->
                                  </div>
                              </div>
                              <div class="text-end">
                                  <strong>{{ parseFloat(asset.networks_balance[0].balance).toFixed(asset.networks_balance[0].decimals) }} {{ asset.symbol }}</strong>
                                  
                                  <div class="text-small">
                                      <span class="badge badge-secondary">
                                          <!-- <ion-icon name="arrow-up-outline"></ion-icon> -->
                                          ~{{ parseFloat(asset.networks_balance[0].balance * asset.price.general).toFixed(2).toLocaleString() }} COP
                                      </span>
                                      <!-- <small>{{ currency }}</small> -->
                                  </div>
                              </div>
                          </div>
                        </div>
                      </li>
                    </template>
                    <template v-else-if="asset.networks_balance.length >= 2">
                      <li v-bind:key="'c_i'+c_i">
                        <div class="item">
                          <div class="icon-box text-success">
                              <img :src="asset.image" height="100%" />
                          </div>
                          <div class="in">
                              <div>
                                  <strong>{{asset.name}}</strong>
                                  <div class="text-small text-secondary">
                                    <!-- Compra: ~{{ asset.price.buy }} COP = 1 {{asset.symbol}} || 
                                    Venta:   1 {{asset.symbol}}  = ~{{ asset.price.sell }} COP -->
                                  </div>
                                  <div class="text-small" v-if="asset.networks_balance.length == 1">
                                    <div :title="asset.networks_balance[0].network.name" data-bs-toggle="tooltip" data-bs-placement="top">
                                      <span class="badge text-secondary align-middle">
                                        <img :src="asset.networks_balance[0].network.image" height="18px" />
                                      </span>
                                      {{ parseFloat(asset.networks_balance[0].balance).toFixed(asset.networks_balance[0].decimals) }} {{ asset.symbol }}
                                    </div>
                                  </div>
                                  
                                  <div class="text-small">
                                    <div v-for="(item, i) in asset.networks_balance" v-bind:key="'item_'+i" :title="item.network.name" data-bs-toggle="tooltip" data-bs-placement="top">
                                      <span class="badge text-secondary align-middle">
                                        <img :src="item.network.image" height="18px" />
                                      </span>
                                      {{ parseFloat(item.balance).toFixed(item.decimals) }} {{ asset.symbol }}
                                      <br>
                                    </div>
                                  </div>
                              </div>
                              <div class="text-end">
                                  <strong>{{asset.balance}} {{asset.symbol}}</strong>
                                  <div class="text-small">
                                      <span class="badge badge-secondary">
                                          <!-- <ion-icon name="arrow-up-outline"></ion-icon> -->
                                          ~{{ parseFloat(asset.amount).toFixed(2) }} COP
                                      </span>
                                      <!-- <small>{{ currency }}</small> -->
                                  </div>
                              </div>
                          </div>
                        </div>
                      </li>
                    </template>
                </template>
                <!-- <li v-for="(currency, c_i) in currencies" v-bind:key="'c_i'+c_i">
                    <div class="item">
                        <div class="icon-box text-success">
                            <img :src="currency.image" height="100%" />
                        </div>
                        <div class="in">
                            <div>
                                <strong>{{currency.name}}</strong>
                                <div class="text-small text-secondary">
                                  Compra: ~{{ currency.price.buy }} COP = 1 {{currency.symbol}} || 
                                  Venta:   1 {{currency.symbol}}  = ~{{ currency.price.sell }} COP
                                </div>
                                <div class="text-small">
                                  <template v-for="(asset, a) in currency.assets">
                                    <div v-bind:key="'asset_'+a" v-if="asset.network.deposit == true">
                                      <span class="badge text-secondary align-middle">
                                        <img :src="asset.network.currency.image" height="18px" />
                                      </span>
                                      {{asset.network.name}}: {{ parseFloat(asset.balance).toFixed(asset.currency.decimals) }} {{ asset.currency.symbol }}
                                      <br>
                                    </div>
                                  </template>
                                </div>
                            </div>
                            <div class="text-end">
                                <strong>{{currency.balance}} {{currency.symbol}}</strong>
                                <div class="text-small">
                                    <span class="badge badge-secondary">
                                        <ion-icon name="arrow-up-outline"></ion-icon>
                                        ~{{ parseFloat(currency.amount).toFixed(2) }} COP
                                    </span>
                                    <small>{{ currency }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </li> -->
                <!-- * ítem -->
            </ul>
        </div>
    </div>
    <!-- Portafolio -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'HomeView',
  data() {
    return {
      //   networks: [],
      //   currencies: [],
      // loading: false,
      // portfolio: [],
      assets: [],
      form: {
        network: 0,
        asset: 0,
      }
    };
  },
  matches: {
    'form.network'() {
      this.form.asset = 0;
    }
  },
  computed: {
    ...mapState(['userData', 'balance', 'last', 'portfolio', 'loading']),
    networks() {
      return this.$root.options.networks;
    },
    currencies() {
      return this.$root.currencies;
    },
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
  },
  methods: {
    ...mapActions(['transactionsList', 'networksAPI', 'currenciesAPI', 'getPortfolio']),
  },
}
</script>
